import * as React from 'react';

import { bemBlock } from 'af-utils/bem.util';

import styles from './styles.module.scss';

interface Props {
	isHeader?: boolean;
	message?: string;
	className?: string;
}

const EmptyCell: React.FC<Props> = ({ isHeader = false, message, className }) => {
	const _className = bemBlock(styles['empty-cell'], { header: isHeader });

	const defaultValue = isHeader ? '' : 'N/A';

	return (
		<div className={[_className, className].join(' ')}>
			{message ?? defaultValue}
		</div>
	);
};

export default React.memo(EmptyCell);
